import type React from 'react';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import AppRouter from './components/AppRouter';
import { AuthProvider } from './context/AuthContext';
import { CustomerCacheProvider } from './context/CustomerCacheContext';
import { PoolCacheProvider } from './context/PoolCacheContext';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <PoolCacheProvider>
        <CustomerCacheProvider>
          <Router>
            <AppRouter />
            <Toaster />
          </Router>
        </CustomerCacheProvider>
      </PoolCacheProvider>
    </AuthProvider>
  );
};

export default App;
